module.exports = __webpack_public_path__ + "static/media/opentable.1ef485d8.png";